module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/bg-2-d62c66b52080b80dc40b00cde4239a70.png";